import { gql } from "@apollo/client";

export const ACCEPT_INVITE = gql`
  mutation AcceptInvite(
    $token: String!
    $name: String!
    $lastname: String!
    $phone: String!
    $password: String!
  ) {
    acceptInvite(
      token: $token
      name: $name
      lastname: $lastname
      phone: $phone
      password: $password
    ) {
      token
      user {
        id
        name
        lastname
        subuser_id
        privileges
        partner {
          id
          status
          company_name
          owner_name
          owner_lastname
          logo
          branches
        }
        branch {
          id
          name
        }
      }
      settings {
        id
        type
        pref_key
        pref_value
        is_global
      }
    }
  }
`;
